import { render, staticRenderFns } from "./index.vue?vue&type=template&id=a59768c4&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=a59768c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a59768c4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a59768c4')) {
      api.createRecord('a59768c4', component.options)
    } else {
      api.reload('a59768c4', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=a59768c4&scoped=true&", function () {
      api.rerender('a59768c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/account/exchangeWithDrawal/index.vue"
export default component.exports